export const FETCH_FIRST_PAGE = 'FETCH_FIRST_PAGE'
export const FETCH_ADDITIONAL = 'FETCH_ADDITIONAL'

export const UPDATE_QUERY_STRING = 'UPDATE_QUERY_STRING'
export const INCREMENT_PAGE = 'INCREMENT_PAGE'
export const RESET_PAGE_NUMBER = 'RESET_PAGE_NUMBER'
export const SET_LOADING = 'SET_LOADING'
export const UNSET_LOADING = 'UNSET_LOADING'
